import { FC } from 'react'
import { ReactNode } from 'react'

import { Dropdown, DropdownOption, DropdownValue } from '@inno-ui/dropdown'
import { Label } from '@inno-ui/label'

import styles from './PreferenceDropdownField.module.scss'

type PreferenceDropdownFieldProps = {
  label: string
  hint: ReactNode
  items: DropdownOption[]
  value: string
  onChange: (value: DropdownValue) => void
  disabled?: boolean
  note?: ReactNode
}

export const PreferenceDropdownField: FC<PreferenceDropdownFieldProps> = ({
  label,
  hint,
  items,
  value,
  onChange,
  disabled,
  note
}) => {
  return (
    <div className={styles.preferenceSection}>
      <div className={styles.fieldHeader}>
        <Label label={label} hintZIndex={1001} hint={hint} />
      </div>
      <Dropdown
        items={items}
        value={value}
        onChange={onChange}
        disabled={disabled}
        width='100%'
      />
      {note && <p className={styles.fieldNote}>{note}</p>}
    </div>
  )
}
